import React, { useContext } from "react";
import { PlaylistStatus } from "../../../../type";
import { defineMessages, useIntl } from "react-intl";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import { useUpdateStatusMutation } from "../../../../api/useMutations";
import { sessionStore } from "../../../../../../../contexts/SessionContext";

type Props = {
    playlistId: string | undefined;
    onArchive?: () => void;
    className?: string;
};

const ArchiveButton = ({ playlistId, onArchive, className }: Props) => {
    const {
        session: { userId },
    } = useContext(sessionStore);
    const intl = useIntl();

    const { mutate: updatePlaylistStatus } = useUpdateStatusMutation();

    const handleArchivePlaylist = () => {
        if (!playlistId) return;
        const playlistToArchive = {
            learning_set_id: playlistId,
            author_id: userId,
            status: { status: PlaylistStatus.ARCHIVED },
        };
        updatePlaylistStatus(playlistToArchive, {
            onSuccess: () => {
                // TODO: handle error and success with toasts
                onArchive && onArchive();
            },
        });
    };

    return (
        <Button
            className={className}
            label={intl.formatMessage(messages.playlistArchive)}
            icons={[{ path: "archive" }]}
            onClick={handleArchivePlaylist}
            disabled={!playlistId}
        />
    );
};
export default ArchiveButton;

const messages = defineMessages({
    playlistArchive: {
        id: "playlist-archive-button",
        defaultMessage: "Archive",
    },
});
